import { LabelGenerator } from '../../types';

export const isMarketLeading: LabelGenerator = (product) =>
  product.display.labels.includes('market_leading_rate') && 'MarketLeadingRate';
